<template>
  <el-card class="box-card" shadow="never">
    <div slot="header" class="clearfix">
      <span>✅ Suivi Certification & Objectifs</span>
    </div>
    <el-table v-loading="loading" :data="tableData" style="width: 100%" height="450">
      <el-table-column prop="indicateur" label="Indicateur" min-width="150" />

      <el-table-column
        prop="surface"
        label="Surface Bio (ha)"
        align="right"
        min-width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.surface | numberFormat }} ha
        </template>
      </el-table-column>

      <el-table-column
        prop="surface_totale"
        label="Surface Totale (ha)"
        align="right"
        min-width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.surface_totale | numberFormat }} ha
        </template>
      </el-table-column>

      <el-table-column label="% Campagne" min-width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.pourcentage !== null" class="progress-container">
            <el-progress
              :percentage="scope.row.pourcentage"
              :color="
                getProgressColor(scope.row.pourcentage, scope.row.objectif)
              "
              :stroke-width="18"
              :text-inside="true"
            />
          </div>
          <span v-else class="text-muted">-</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="objectif"
        label="Objectif"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.objectif !== null"
            :type="getObjectifStatus(scope.row.pourcentage, scope.row.objectif)"
          >
            {{ scope.row.objectif }}%
          </el-tag>
          <span v-else class="text-muted">-</span>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
export default {
  name: 'CertificationTable',
  filters: {
    numberFormat(value) {
      if (!value) {
        return '0';
      }
      return new Intl.NumberFormat('fr-FR').format(value);
    },
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableData() {
      // Si aucune donnée n'est passée, on peut afficher des données de démo ou vide
      // Ici on retourne simplement la prop data
      return this.data;
    },
  },
  methods: {
    getProgressColor(percentage, objective) {
      if (percentage >= objective) {
        return '#67C23A'; // Green
      } else if (percentage >= objective * 0.7) {
        return '#E6A23C'; // Yellow
      } else {
        return '#F56C6C'; // Red
      }
    },
    getObjectifStatus(percentage, objective) {
      if (percentage >= objective) {
        return 'success';
      } else if (percentage >= objective * 0.7) {
        return 'warning';
      } else {
        return 'danger';
      }
    },
  },
};
</script>

<style scoped>
.progress-container {
  padding-right: 10px;
}
.text-muted {
  color: #909399;
}
</style>
